const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Sobre nós",
    to: "/sobre",
  },
  {
    text: "Serviços",
    to: "/servicos",
  },
  {
    text: "Produtos",
    to: "/produtos",
  },
  {
    text: "Clientes",
    to: "/#clientes",
  },
  {
    text: "Vídeos",
    to: "/#videos",
  },
  {
    text: "Novidades",
    to: "/novidades",
  },
];

export { server, menu };
